import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, SponsorsData } from './types';

const initialState: initState = {
  list: {
    data: [],
    meta: {
      totalCount: 0
    },
  },
};

const sponsorsSlice = createSlice({
  name: 'sponsors',
  initialState,
  reducers: {
    setSponsorsData(state: initState, action: PayloadAction<{ list: SponsorsData }>) {
      state.list = action.payload.list;
    },
  },
});

export const { setSponsorsData } = sponsorsSlice.actions;

export default sponsorsSlice.reducer;
